import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    rounded: "",
    size: "small",
    variant: _ctx.text ? 'text' : undefined,
    disabled: _ctx.disabled,
    class: _normalizeClass(["small-button text-transform-initial p14 p14-sb", _ctx.getClass()])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["variant", "disabled", "class"]))
}